import {
  INIT_DEVICES,
  EDIT_DEVICE,
  SERVICE_DEVICE,
  EDIT_STATUS_HISTORY,
  ADD_DEVICES,
  EDIT_DEVICE_STATUS,
  CLEAR_DEVICES,
  UPDATE_SINGLE_DEVICE,
} from '../type';
import axiosInstance from '../../config/axios.config';
import { success } from './loader.action';
import { clearUipps, getOnlyOneUippsFromServer, initUippsFromServer } from './uipps.action';
import { initStatusesFromServer } from './statuses.action';
import { initIurAndroidId, initUippsAndroidId } from '../actions/options.action';

export const initDevices = (devices) => ({
  type: INIT_DEVICES,
  payload: devices,
});

export const addDevices = (device) => ({
  type: ADD_DEVICES,
  payload: device,
});

export const editDevices = (device) => ({
  type: EDIT_DEVICE,
  payload: device[0],
});

export const editDevicesStatus = (status) => ({
  type: EDIT_DEVICE_STATUS,
  payload: status,
});

export const serviceDevices = (device) => ({
  type: SERVICE_DEVICE,
  payload: device,
});

export const editStatusHistory = (statusHistory) => ({
  type: EDIT_STATUS_HISTORY,
  payload: statusHistory,
});

export const clearDevices = () => ({
  type: CLEAR_DEVICES,
  payload: [],
});

export const updateSingle = (device) => ({
  type: UPDATE_SINGLE_DEVICE,
  payload: device,
});

// получение всех устройств
export const initDevicesFromServer = (query) => async (dispatch, getState) => {
  try {
    const result = await axiosInstance(`/api/devices${query}`);

    if (result.data && result.status === 200) {
      dispatch(initDevices(result.data));
      return result; // Возвращаем данные для использования в .then()
    }
  } catch (error) {
    console.log(error);
  }
};

// добавление нового устройства
export const newDeviceFromServer = (formData) => async (dispatch, getState) => {
  try {
    const lastQuery = getState().lastQuery; // Достаём query из стейта

    const response = await axiosInstance.post('/api/devices', formData);
    if (response.status === 201) {
      dispatch(success());
      if (formData?.typeId === 4) {
        dispatch(clearUipps());
        dispatch(initUippsFromServer(lastQuery));
      } else {
        dispatch(clearDevices());
        dispatch(initDevicesFromServer(lastQuery));
      }
    }
  } catch (error) {
    console.log(error);
  }
};

// изменение устройства
export const editDeviceFromServer = (payload, deviceId, typeUipps) => async (dispatch) => {
  try {
    const response = await axiosInstance.put(`/api/devices/${deviceId}`, payload);
    if (response.status === 200) {
      // записываем в стейт сообщение об успешном выполнении

      dispatch(success());
      if (typeUipps) {
        dispatch(getOnlyOneUippsFromServer(deviceId));
      } else {
        dispatch(getOnlyOneDeviceFromServer(deviceId));
      }
    }
  } catch (error) {
    console.log(error);
  }
};

// Получение обновлённых данных устройства после изменения его данных
export const getOnlyOneDeviceFromServer = (id) => async (dispatch) => {
  try {
    const uippsData = await axiosInstance(`/api/devices?id=${id}`);
    if (uippsData.data[0]) {
      dispatch(updateSingle(uippsData.data[0]));
    }
  } catch (error) {
    console.log(error);
  }
};

//проведение ТО
export const deviceServiceFromServer = (payload, deviceId, typeUipps) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(`/api/devices/${deviceId}/maintenance`, payload);
    if (response.status === 201) {
      dispatch(success());
      if (typeUipps) {
        dispatch(getOnlyOneUippsFromServer(deviceId));
      } else {
        dispatch(getOnlyOneDeviceFromServer(deviceId));
      }
      dispatch(initStatusesFromServer(deviceId, 'archive'));
    }
  } catch (error) {
    console.log(error);
  }
};

// передача устройства на хранение
export const transferDeviceForStorage =
  ({ payload, deviceId, typeId, path }) =>
  async (dispatch) => {
    try {
      const response = await axiosInstance.post(`/api/devices/${deviceId}/storage`, payload);
      if (response.status === 201 && response.data.statusId) {
        dispatch(success());
        if (typeId !== 4) {
          dispatch(getOnlyOneDeviceFromServer(response.data.deviceId));
        }
        if (typeId === 4) {
          dispatch(getOnlyOneUippsFromServer(response.data.deviceId));
        }
        await dispatch(initStatusesFromServer(response.data.deviceId, path));
      }
    } catch (error) {
      console.log(error);
    }
  };

// выдача устройства в эксплуатацию
export const transferDeviceForOperation =
  ({ payload, deviceId, isUipps, path }) =>
  async (dispatch) => {
    try {
      const response = await axiosInstance.post(`/api/devices/${deviceId}/usage`, payload);
      if (response.status === 201 && response.data.statusId && !isUipps) {
        dispatch(success());
        dispatch(getOnlyOneDeviceFromServer(deviceId));
      }
      if (response.status === 201 && response.data.statusId && isUipps) {
        dispatch(success());
        dispatch(getOnlyOneUippsFromServer(deviceId));
      }
      dispatch(initStatusesFromServer(deviceId, path));
    } catch (error) {
      console.log(error);
    }
  };

// передача устройства в ремонт
export const transferDeviceForRepair =
  ({ payload, deviceId, typeId, path }) =>
  async (dispatch) => {
    try {
      const response = await axiosInstance.post(`/api/devices/${deviceId}/repair`, payload);
      if (response.status === 201 && response?.data?.statusId) {
        dispatch(success());
        if (typeId !== 4) {
          dispatch(getOnlyOneDeviceFromServer(deviceId));
        }
        if (typeId === 4) {
          dispatch(getOnlyOneUippsFromServer(deviceId));
        }
        dispatch(initStatusesFromServer(deviceId, path));
      }
    } catch (error) {
      console.log(error);
    }
  };

// списание устройства
export const transferDeviceForWriteOff =
  ({ payload, typeId, deviceId }) =>
  async (dispatch) => {
    try {
      const response = await axiosInstance.post(`/api/devices/${deviceId}/archive`, payload);
      if (response?.status === 201 && response?.data?.statusId) {
        dispatch(success());
        if (typeId !== 4) {
          dispatch(getOnlyOneDeviceFromServer(deviceId));
        }
        if (typeId === 4) {
          dispatch(getOnlyOneUippsFromServer(deviceId));
        }
        dispatch(initStatusesFromServer(deviceId, 'archive'));
      }
    } catch (error) {
      console.log(error);
    }
  };

// запрос на получение массив android_id [string]
export const initAndroidIdFromServer =
  ({ typeId }) =>
  async (dispatch) => {
    try {
      const { data } = await axiosInstance(`/api/devices/unauthorized/${typeId}`);
      // в зависимости от typeId назначаем соответствующие экшены 1-IUR, 4-UIPPS
      const typeActions = {
        1: initIurAndroidId,
        4: initUippsAndroidId,
      };
      const action = typeActions[typeId];
      if (action) {
        dispatch(action(data));
      }
    } catch (error) {
      console.log(error);
    }
  };

// запрос на получение массива sim-info по androidId
export const initSimInfoFromServer =
  ({ androidId, typeId }) =>
  async (dispatch) => {
    try {
      const { data } = await axiosInstance.get('/api/devices/sim-info', {
        params: {
          androidId,
          typeId,
        },
      });
      if (data) {
        return data;
      }
    } catch (error) {
      console.error(error);
    }
  };
